import styles from "src/features/Event/components/TopPageHeader/topPageHeader.module.css";
import { FaRegBell } from "react-icons/fa";
import { MdOutlinePersonSearch } from "react-icons/md";
import streetLogo from "src/assets/images/street_logo_white.svg";
import { useCallback, useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAtom, useSetAtom } from "jotai";
import globalStyles from "src/global.module.css";
import Marquee from "react-fast-marquee";
import { donateManual } from "src/common/link";
import SegmentedControl from "src/components/layout/SegmentedControl/SegmentedControl";
import TopPageFilterModal from "../TopPageFilterModal/TopPageFilterModal";
import {
    searchKeywordAtom,
    topPageEventListObjectAtom,
    segmentedControlCurrentIndexAtom,
    topPageSegmentedControlKeyAtom,
} from "../../event.atom";
import { topPageSegmentOptions } from "../../event.constant";
import type { TopPageSegmentedControlKey } from "../../event.type";
import useNotification from "src/features/Notification/hooks/useNotification";

const TopPageHeader: React.FC = () => {
    const navigate = useNavigate();
    const [isModalOpen, setModalOpen] = useState(false);
    const [searchKeyword, setSearchKeyword] = useAtom(searchKeywordAtom);
    const setTopPageEventListObject = useSetAtom(topPageEventListObjectAtom);
    const { notificationObjectList: notificationList } = useNotification();
    const [lastSeenCount, setLastSeenCount] = useState(0);
    const [segmentedControlCurrentIndex, setSegmentedControlCurrentIndex] =
        useAtom(segmentedControlCurrentIndexAtom);
    const [, setTopPageSegmentedControlKey] = useAtom(topPageSegmentedControlKeyAtom);
    const segmentControlRef = useRef(null);

    useEffect(() => {
        const saved = localStorage.getItem("lastSeenNotificationCount");
        if (saved) setLastSeenCount(Number(saved));
    }, []);

    const unreadCount = Math.max(0, notificationList.length - lastSeenCount);

    const handleModalOpen = () => {
        setModalOpen(true);
    };

    const navigateNotificationPage = () => {
        setLastSeenCount(notificationList.length);
        localStorage.setItem("lastSeenNotificationCount", String(notificationList.length));
        navigate("/notification");
    };

    const navigateArtistSearchingPage = () => {
        navigate("/artist-searching");
    };

    const handelSearchKeywordOnEnter = (
        e: React.KeyboardEvent<HTMLInputElement>
    ) => {
        if (e.key === "Enter") {
            setTopPageEventListObject(true);
        }
    };

    const [playBool, setPlayBool] = useState(true);

    const CycleComplete = useCallback(() => {
        setPlayBool(false);
        setTimeout(() => {
            setPlayBool(true);
        }, 3000);
    }, []);

    const handelNavigateDonateManual = () => {
        window.open(donateManual, "_blank");
    };

    return (
        <>
            <div className={styles.top_header_container}>
                <div className={styles.tool_area}>
                    <div
                        className={styles.tool_item}
                        onClick={navigateNotificationPage}
                        onKeyDown={navigateNotificationPage}
                        role="button"
                        tabIndex={0}
                        aria-label="通知ページへ"
                    >
                        <FaRegBell className={styles.tool_item_icon_bell} />
                        {unreadCount > 0 && <div className={styles.new_badge}>{unreadCount}</div>}
                    </div>
                    <img
                        src={streetLogo}
                        className={styles.street_logo}
                        alt="street_logo"
                    />
                    <div
                        className={styles.tool_item}
                        onClick={navigateArtistSearchingPage}
                        onKeyDown={navigateArtistSearchingPage}
                        role="button"
                        tabIndex={0}
                        aria-label="アーティスト検索ページへ"
                    >
                        <MdOutlinePersonSearch
                            className={styles.tool_item_icon_search}
                        />
                    </div>
                </div>
                <Marquee
                    speed={40}
                    delay={2}
                    onCycleComplete={CycleComplete}
                    play={playBool}
                >
                    <p
                        onClick={handelNavigateDonateManual}
                        onKeyDown={handelNavigateDonateManual}
                        role="none"
                    >
                        投げ銭のやりかたマニュアルを公開しました。アクセスは
                        <span className={globalStyles.link_text}>こちら</span>
                        から！
                    </p>
                </Marquee>
                <div className={styles.search_and_filter_area}>
                    <div className={styles.search_area}>
                        <div className={styles.magnifying_glass_container}>
                            <span className={styles.magnifying_glass} />
                        </div>
                        <input
                            type="text"
                            className={styles.search_input}
                            placeholder="例）まちなかパフォーマンス"
                            value={searchKeyword}
                            onChange={(e) => {
                                return setSearchKeyword(e.target.value);
                            }}
                            onKeyDown={handelSearchKeywordOnEnter}
                        />
                    </div>
                    <div
                        className={styles.filter_button}
                        onClick={handleModalOpen}
                        onKeyDown={handleModalOpen}
                        role="button"
                        tabIndex={0}
                    >
                        <div className={styles.hamburger_menu_icon_container}>
                            <div className={styles.hamburger_menu_icon} />
                        </div>
                        <p className={styles.filter_button_text}>フィルター</p>
                    </div>
                </div>
            </div>
            <div className={styles.segment_container}>
                <SegmentedControl
                    name="top"
                    segments={topPageSegmentOptions}
                    callback={(val: string, index: number) => {
                        setTopPageSegmentedControlKey(val as TopPageSegmentedControlKey);
                        setSegmentedControlCurrentIndex(index);
                        setTopPageEventListObject(true);
                    }}
                    controlRef={segmentControlRef}
                    defaultIndex={segmentedControlCurrentIndex}
                />
            </div>
            <TopPageFilterModal
                isModalOpen={isModalOpen}
                setModalOpen={setModalOpen}
            />
        </>
    );
};

export default TopPageHeader;
